module.exports = ".modal-dialog {\n  position: fixed;\n  width: 50vw !important;\n  height: 30vh !important;\n  left: 25vw;\n  top: 35vh;\n}\n\n"